exports = module.exports = require("../../../../../build-utils/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".styles__icon___2xt8g {\n  margin-right: 10px;\n  font-size: 20px;\n}\n", "",{"version":3,"sources":["/var/www/service-plans/common/client/modules/quote/components/EmailQuoteButton/styles.less","styles.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;ACCF","file":"styles.less","sourcesContent":[".icon {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n@primary-color: #2882b2;",".icon {\n  margin-right: 10px;\n  font-size: 20px;\n}\n"]}]);

// Exports
exports.locals = {
	"icon": "styles__icon___2xt8g"
};